package one.devsbox.www.ui.locations

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.ui.widgets.OpeningHours
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.stringResource

@Composable
fun LocationDetails(details: SharedIO.Location) {
    val primaryColor = MaterialTheme.colorScheme.primary
    val backgroundColor = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.3f)

    BoxWithConstraints(
        modifier = Modifier
            .fillMaxWidth()
            .border(BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant), RoundedCornerShape(8.dp))
            .background(Color.Transparent)
            .padding(16.dp)
    ) {
        val isWide = maxWidth >= 1000.dp
        if (isWide) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                // Opening Hours Column
                OpeningHours(
                    modifier = Modifier.weight(1f),
                    openingHours = details.oh,
                    backgroundColor = backgroundColor,
                    primaryColor = primaryColor
                )

                // Stats Grid
                Column(Modifier.width(400.dp).align(Alignment.CenterVertically)) {
                    LocationStatsSection(details)
                }
            }
        } else {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                // Opening Hours Column
                OpeningHours(
                    modifier = Modifier.fillMaxWidth(),
                    openingHours = details.oh,
                    backgroundColor = backgroundColor,
                    primaryColor = primaryColor
                )

                // Stats Grid
                LocationStatsSection(details)
            }
        }
    }
}

@Composable
private fun LocationStatsSection(details: SharedIO.Location) {
    Column(Modifier.fillMaxWidth()) {
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            StatCard(
                stringResource(Res.string.ui_locations_details_indoor_nodes),
                details.devices.count { it.type == 2 }.toString().padStart(2, '0'),
                Modifier.weight(1f)
            )
            StatCard(
                stringResource(Res.string.ui_locations_details_outdoor_nodes),
                details.devices.count { it.type == 4 }.toString().padStart(2, '0'),
                Modifier.weight(1f)
            )
        }
        Spacer(Modifier.height(16.dp))
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            StatCard(
                stringResource(Res.string.ui_locations_details_online_devices),
                details.devices.count { it.online }.toString().padStart(2, '0'),
                Modifier.weight(1f),
                MaterialTheme.colorScheme.primary
            )
            StatCard(
                stringResource(Res.string.ui_locations_details_offline_devices),
                details.devices.count { !it.online }.toString().padStart(2, '0'),
                Modifier.weight(1f),
                MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
    }
}

@Composable
private fun StatCard(
    label: String,
    value: String,
    modifier: Modifier = Modifier,
    valueColor: Color = MaterialTheme.colorScheme.onSurface
) {
    Column(
        modifier = modifier
            .border(1.dp, MaterialTheme.colorScheme.outlineVariant)
            .padding(16.dp)
    ) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelLarge,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )
        Text(
            text = value,
            fontSize = 32.sp,
            fontWeight = FontWeight.Bold,
            color = valueColor,
            fontFamily = FontFamily.Monospace
        )
    }
}

